export class ErpOrder {
  totalPriceNetto?: number;
  totalPriceBrutto?: number;
  mwstGrouped?: {
    percentage: number;
    amount: number;
  }[];
  externalId?: string;
  externalBusinessPartnerId?: string;
  positions?: {
    id: number;
    externalId: string;
    name: string;
    amount: number;
    amountBrutto: number;
    tax: number;
    quantity: number;
    additionalText: string;
  }[];
  connectionObjectReadable?: string;
  commissioningDateReadable?: string;
  stateModifiedDate?: Date;
  state?: 'created' | 'error' | 'new';
}
